<script setup>
import { useHead } from "@unhead/vue";
import { onUnmounted, defineEmits } from 'vue';
import { useNotificationStore } from '@/store';

const FilePickerJs = "https://cdn01.boxcdn.net/platform/elements/17.1.0/fr-FR/picker.js";
const FilePickerCss = "https://cdn01.boxcdn.net/platform/elements/17.1.0/fr-FR/picker.css";

const emits = defineEmits(['choose', 'cancel']);

const props = defineProps({
  folderId: String,
  accessToken: String,
  modal: Boolean,
});

function handleChoose(files) {
  emits("choose", files);
}

const BoxCode = useHead({
  script: [
    {
      type: "text/javascript",
      src: FilePickerJs,
      onload: () => {
        const accessToken = props.accessToken;
        const filePicker = new Box.FilePicker();
        filePicker.show(props.folderId, accessToken, {
          onClose: null,
          extensions: ["pdf"],
          maxSelectable: 1,
          canUpload: true,
          canSetShareAccess: false,
          canCreateNewFolder: false,
          modal: props.modal ? {
            buttonLabel: "Sélectionner une cession",
            // modalClassName: "w-1/2 h-1/2 m-auto",
            // overlayClassName: "w-1/2 h-1/2 m-auto",
          } : null,
          container: "#box-file-picker",
          logoUrl: '/logo_blue.svg'// 'https://ucarecdn.com/b873a4a9-e499-41ed-bce9-322726d13bf1/-/preview/500x500/-/quality/smart_retina/-/format/auto/'
        });

        filePicker.addListener('choose', handleChoose);
        filePicker.addListener('cancel', () => emits("cancel"));
      }
    },
  ],
  link: [
    {
      rel: "stylesheet",
      href: FilePickerCss,
    },
  ],
});
onUnmounted(() => {
    filePicker?.removeListener('choose', handleChoose);
    filePicker?.removeListener('cancel');
    BoxCode.dispose()
})
</script>
<template>
  <div id="box-file-picker"></div>
</template>
<style>
/** Strange UI issue */
.icon-close {
  @apply mx-auto;
}
.icon-check {
  @apply mx-auto;
}
</style>